export default {

  data: () => ({

  }),
};
